import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import LanguageToggle from "./LanguageToggle";
import AdminLogin from "./AdminLogin";
import "./Navbar.css";
import logo from "../assets/logo.png";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded"; // Changed back to HomeRounded
import MenuIcon from "@mui/icons-material/Menu";
// Import AdminPanelSettingsIcon is still here but won't be used

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAdminLoginOpen, setIsAdminLoginOpen] = useState(false);
  const navigate = useNavigate();
  const { t, getLanguageUrl } = useLanguage();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigation = (path: string) => {
    // Use the language-specific URL
    const languagePath = getLanguageUrl(path);
    navigate(languagePath);
    setIsMenuOpen(false); // Close the menu after navigation
  };

  return (
    <>
      <nav className="navbar">
        <div className="nav-right">
          <div className="logo-container">
            <img src={logo} alt="Arzei Chessed Logo" className="logo" />
            <span className="organization-name">{t("organizationName")}</span>
          </div>
        </div>

        <button className="menu-toggle" onClick={toggleMenu}>
          <MenuIcon />
        </button>

        <div className={`nav-center ${isMenuOpen ? "show" : ""}`}>
          <button
            className="nav-button"
            onClick={() => handleNavigation("/gallery")}
          >
            {t("gallery")}
          </button>
          <button
            className="nav-button"
            onClick={() => handleNavigation("/projects")}
          >
            {t("our.projects")}
          </button>
          <button
            className="nav-button"
            onClick={() => handleNavigation("/about")}
          >
            {t("about.us")}
          </button>
          <button
            className="nav-button"
            onClick={() => handleNavigation("/donate")}
          >
            {t("your.donation")}
          </button>
          <button
            className="nav-button"
            onClick={() => handleNavigation("/contact")}
          >
            {t("contact.us.button")}
          </button>
        </div>

        <div className="nav-left">
          <button className="home-button" onClick={() => handleNavigation("/")}>
            <HomeRoundedIcon sx={{ fontSize: 28 }} />{" "}
            {/* Changed back to HomeRoundedIcon */}
          </button>
          {/* Admin button removed */}
          <LanguageToggle />
        </div>
      </nav>

      {/* Keep the AdminLogin component in case it's needed in the future */}
      <AdminLogin
        isOpen={isAdminLoginOpen}
        onClose={() => setIsAdminLoginOpen(false)}
      />
    </>
  );
};

export default Navbar;
